export default {
    'FlujoEtapasTabla.FlujoDescripcion': 'Descripcion',
    'FlujoEtapasTabla.EtapaActual': 'Etapa Actual',
    'FlujoEtapasTabla.EtapaSiguiente': 'Etapa Siguiente',
    'FlujoEtapasTabla.Estado': 'Estado',
};
